import { render } from "./SecretC.vue?vue&type=template&id=1d34f9d0&scoped=true"
import script from "./SecretC.vue?vue&type=script&lang=js"
export * from "./SecretC.vue?vue&type=script&lang=js"

import "./SecretC.vue?vue&type=style&index=0&id=1d34f9d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d34f9d0"]])

export default __exports__